import '@carvana/core-auth';

type FailedCharge = {
  amount: number;
  isResolved: boolean;
  isExpired: boolean;
};

type CheckoutSession = {
  id: string;
};

export const getFailedPaymentDetails = () =>
  fetch(
    `${process.env.APIK_BASE_URL}/oec/stripe/api/v1/charges/getfailedcharge`
  )
    .then((res) =>
      res.status === 200 ? (res.json() as Promise<FailedCharge>) : undefined
    )
    .then((response) =>
      response
        ? ({ hasFailedPayment: true, ...response } as const)
        : ({ hasFailedPayment: false } as const)
    );

export const createCheckoutSession = (successUrl: string, cancelUrl: string) =>
  fetch(
    `${
      process.env.APIK_BASE_URL
    }/oec/stripe/api/v1/checkoutsessions/CreateCheckoutSession?successUrl=${encodeURI(
      successUrl
    )}&cancelUrl=${encodeURI(cancelUrl)}`,
    {
      method: 'POST',
    }
  ).then((res) => res.json() as Promise<CheckoutSession>);
